import { buildFonts, fontlist } from '@monolithmtl/fonts'
import { makeFluids } from '@monolithmtl/scales'

const fluid = makeFluids(
  {
    'size-running': ['18px', '32px', false],
    'size-caption': ['12px', '18px'],
    'size-text': ['20px', '58px'],
    'size-subtitle': ['32px', '86px'],
    'size-name': ['36px', '120px'],
    'size-title': ['36px', '180px'],
  },
  ['375px', '2500px']
)

export const scales = {
  fontSizes: fluid.scale,
  fontWeights: {
    body: 400,
    heading: 400,
    caption: 400,
    name: 400,
  },
  lineHeights: {
    body: 1.3,
    caption: 1.3,
    name: 0.95,
    heading: 1,
  },
}

export const rootFontStyles = {
  fontSize: 1,
  fontFamily: 'suisse',
  lineHeight: 'body',
  fontWeight: 'body',

  '--rte': '1.35em',
  '.-rte + .-rte': { mt: 'var(--rte)' },

  ...fluid.properties,
}

const common = (type = 'body', uppercase = false) => ({
  textTransform: uppercase ? 'uppercase' : null,
  fontFamily: type,
  fontWeight: type,
  lineHeight: type,
  crops: 'suisse',
})

export default buildFonts([fontlist(['suisse']), scales], {
  fonts: {
    heading: 'inherit',
    body: 'inherit',
    name: 'inherit',
    caption: 'inherit',
    monospace: 'Menlo, monospace',
  },
  variants: {
    key: 'text',
    heading: { variant: 'text.title' },
    __default: { variant: 'text.small' },
    __cropped: {
      title: { fontSize: 5, ...common('heading', true) },
      name: { fontSize: 4, ...common('name', false) },
      subtitle: { fontSize: 3, ...common('heading', true) },
      caption: { fontSize: 1, ...common('caption', true) },
      text: { fontSize: 2, ...common() },
      running: { fontSize: 'var(--size-running)', ...common() },
    },
    small: { variant: 'text.caption' },
  },
})
